export default __webpack_public_path__ + "static/media/logo .52a76878.png";